import { Column, Entity, JoinColumn, ManyToOne } from "typeorm";
import { AnswerHeader } from "./answer-header.entity";
import { CommonColumns } from "./common-columns.entity";
import { Question, QuestionType } from "./question.entity";

@Entity()
export class Answer extends CommonColumns {

  @ManyToOne(() => AnswerHeader, answerHeadr => answerHeadr.answers, { nullable: false, })
  @JoinColumn({ name: 'answer_header_id', referencedColumnName: 'id', })
  answerHeader: AnswerHeader;

  @ManyToOne(() => Question, { nullable: false, })
  @JoinColumn({ name: 'question_id', referencedColumnName: 'id', })
  question: Question;

  // 質問内容は編集される可能性がある
  // 回答時の質問内容をコピーしておく
  @Column({
    name: 'question_type',
    enum: QuestionType,
  })
  questionType: QuestionType;

  // 質問内容は編集される可能性がある
  // 回答時の質問内容をコピーしておく
  @Column({ name: 'question_text', })
  questionText: string;
  
  @Column({ name: 'disp_order', })
  dispOrder: number;

  @Column({ name: 'answer_value', length: 130, })
  answerValue: string;

  @Column({ name: 'answer_sub_value', length: 130, default: '', })
  answerSubValue: string;

  constructor(props: IAnswer) {
    super();
    Object.assign(this, props);
  }
}

export declare type TAnswer = Omit<Answer, 'dummy-no-such-field'>;
export interface IAnswer extends TAnswer {};
